import { render, staticRenderFns } from "./partnerSettlement.vue?vue&type=template&id=4cd5b995"
import script from "./partnerSettlement.vue?vue&type=script&lang=js"
export * from "./partnerSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports